import { render } from "./ConsentDisclaimer.vue?vue&type=template&id=054c4610&scoped=true"
import script from "./ConsentDisclaimer.vue?vue&type=script&lang=js"
export * from "./ConsentDisclaimer.vue?vue&type=script&lang=js"

import "./ConsentDisclaimer.vue?vue&type=style&index=0&id=054c4610&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-054c4610"]])

export default __exports__